var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "metaAdsGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0064E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080FB"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#metaAdsGrad)",
    d: "M4 22c0-5 3.5-10 8.5-10 3.5 0 6 2.2 8.5 6 2.5-3.8 5-6 8.5-6 5 0 8.5 5 8.5 10s-3.5 10-8.5 10c-3.5 0-6-2.2-8.5-6-2.5 3.8-5 6-8.5 6-5 0-8.5-5-8.5-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1c1e",
    d: "M36 33l8-4v12l-8-4v-4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#1a1c1e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaAds);
export default __webpack_public_path__ + "static/media/meta-ads.9c0da75d577e1d0eb88168c1ffe5fb6f.svg";
export { ForwardRef as ReactComponent };